import React from 'react';

const ProductSkeleton = () => {
  return (
    <div className="relative w-[240px] md:w-[300px] py-[1rem] px-1 md:px-4">
      <div className="h-full bg-white rounded-3xl border border-gray-200 shadow-sm flex flex-col relative overflow-hidden">
        {/* Shimmer Effect */}
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent"></div>
        
        {/* IMAGE SKELETON */}
        <div className="relative aspect-[4/3.2] bg-gray-200 rounded-t-3xl">
          {/* Badge Skeleton */}
          <div className="absolute top-5 left-5 w-12 h-6 bg-gray-300 rounded-full"></div>
          
          {/* Heart Icon Skeleton */}
          <div className="absolute top-5 right-5 w-9 h-9 bg-gray-300 rounded-2xl"></div>
        </div>

        {/* CONTENT SKELETON */}
        <div className="px-6 pt-5 pb-6 flex flex-col flex-1 text-center space-y-3">
          {/* Title Skeleton */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto"></div>
          </div>

          {/* Stars Skeleton */}
          <div className="flex justify-center space-x-1">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="w-3 h-3 bg-gray-200 rounded-sm"></div>
            ))}
          </div>

          {/* Price and Button Skeleton */}
          <div className="mt-auto flex items-center justify-between pt-4">
            <div className="h-8 bg-gray-200 rounded w-16"></div>
            <div className="h-8 bg-gray-200 rounded-2xl w-20"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ProductGridSkeleton = ({ count = 12 }) => {
  return (
    <div className="w-full flex flex-wrap justify-start items-start">
      {[...Array(count)].map((_, index) => (
        <ProductSkeleton key={index} />
      ))}
    </div>
  );
};

export { ProductSkeleton, ProductGridSkeleton };